// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-tab-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.message-tab-container button {
  box-shadow: 0 0 5px -2px var(--border-color);
  border-radius: 5px;
  min-width: unset;
}

.message-tab-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-s);
}

.message-tab-table th {
  text-align: left;
  padding-bottom: var(--input-element-gap-small);
  border-bottom: 1px solid #333;
}

.message-tab-table td {
  padding: 2px var(--input-element-gap-small);
  white-space: nowrap;
  vertical-align: top;
}

.message-tab-table tbody tr:hover {
  background-color: rgba(5, 50, 110, 0.5);
  color: white;
  background-blend-mode: multiply;
}

.message-tab-header {
  display: flex;
  gap: var(--input-element-gap);
  align-items: center;
  margin-bottom: var(--input-element-gap);
}

.message-tab-header input[type="text"] {
  flex: 1;
}

.message-tab-checkbox {
  display: flex;
  align-items: center;
  gap: 4px;
}

.message-tab-table-wrapper {
  flex: 1;
  overflow: auto;
  min-height: 0;   /* VERY IMPORTANT */
}

.message-row {
  cursor: pointer;
}

.message-details-row {
  background-color: rgba(255, 255, 255, 0.03);
}

.message-details-table {
  width: 100%;
}

.message-details-key {
  font-weight: bold;
  padding-right: var(--input-element-gap);
  white-space: nowrap;
}

.message-details-empty {
  font-style: italic;
  opacity: 0.7;
}

.message-subtable {
  border-left: 2px solid #444;
  margin-left: 8px;
  padding-left: 8px;
  width: 100%;
}

.message-subtable-key {
  font-weight: bold;
  white-space: nowrap;
  padding-right: var(--input-element-gap);
}

.message-subtable-value {
  white-space: nowrap;
}

.matrix-element {
  text-align: right;
}

.message-details-empty {
  font-style: italic;
  opacity: 0.7;
}

.chart-container {
  position: relative;
  overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/debug-overlay/message-tab/MessageTab.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,cAAc;EACd,aAAa,IAAI,mBAAmB;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".message-tab-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.message-tab-container button {\n  box-shadow: 0 0 5px -2px var(--border-color);\n  border-radius: 5px;\n  min-width: unset;\n}\n\n.message-tab-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--font-size-s);\n}\n\n.message-tab-table th {\n  text-align: left;\n  padding-bottom: var(--input-element-gap-small);\n  border-bottom: 1px solid #333;\n}\n\n.message-tab-table td {\n  padding: 2px var(--input-element-gap-small);\n  white-space: nowrap;\n  vertical-align: top;\n}\n\n.message-tab-table tbody tr:hover {\n  background-color: rgba(5, 50, 110, 0.5);\n  color: white;\n  background-blend-mode: multiply;\n}\n\n.message-tab-header {\n  display: flex;\n  gap: var(--input-element-gap);\n  align-items: center;\n  margin-bottom: var(--input-element-gap);\n}\n\n.message-tab-header input[type=\"text\"] {\n  flex: 1;\n}\n\n.message-tab-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.message-tab-table-wrapper {\n  flex: 1;\n  overflow: auto;\n  min-height: 0;   /* VERY IMPORTANT */\n}\n\n.message-row {\n  cursor: pointer;\n}\n\n.message-details-row {\n  background-color: rgba(255, 255, 255, 0.03);\n}\n\n.message-details-table {\n  width: 100%;\n}\n\n.message-details-key {\n  font-weight: bold;\n  padding-right: var(--input-element-gap);\n  white-space: nowrap;\n}\n\n.message-details-empty {\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.message-subtable {\n  border-left: 2px solid #444;\n  margin-left: 8px;\n  padding-left: 8px;\n  width: 100%;\n}\n\n.message-subtable-key {\n  font-weight: bold;\n  white-space: nowrap;\n  padding-right: var(--input-element-gap);\n}\n\n.message-subtable-value {\n  white-space: nowrap;\n}\n\n.matrix-element {\n  text-align: right;\n}\n\n.message-details-empty {\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.chart-container {\n  position: relative;\n  overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
